import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Page from './Page';
import { getMemberProfileById } from '../../actions/user';
import { loginIfVerified } from '../../actions/auth';
import { fetchGeoLocation } from '../../actions/geo-ip';

function mapStateToProps({ geoIp, auth, user, config }, { match }) {
  return {
    country: geoIp.geoIpInfo.country,
    env: config.env,
    isFetchingLocation: geoIp.isFetching,
    gAppId: config.googleAppId,
    user,
    oneTapError: auth.oneTapError,
    authLoginStatus: auth.status,
    identityHost: config.identityHost,
    payHost: config.payHost,
    payNgHost: config.payNgHost,
    trackerHost: config.trackerHost,
    state: geoIp.geoIpInfo.state,
    path: match.url,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    fetchMember: queryParams => dispatch(getMemberProfileById(queryParams)),
    fetchGeoLocation: () => dispatch(fetchGeoLocation()),
    loginIfVerified: params => dispatch(loginIfVerified(params)),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Page));
